module.exports = __webpack_public_path__ + "img/personal_message_normal.793ef5c6.svg";